module.exports = __webpack_public_path__ + "img/sequence-suidobashi-sp.2c3a1b07.jpg";